import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "alertDanger",
  "use": "alertDanger-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol viewBox=\"0 0 18 18\" xmlns=\"http://www.w3.org/2000/svg\" id=\"alertDanger\">\n<path d=\"M9 17.25C13.5563 17.25 17.25 13.5563 17.25 9C17.25 4.44365 13.5563 0.75 9 0.75C4.44365 0.75 0.75 4.44365 0.75 9C0.75 13.5563 4.44365 17.25 9 17.25ZM12.9584 11.7916L11.7916 12.9584L9 10.1667L6.20836 12.9584L5.04164 11.7916L7.83327 9L5.04164 6.20836L6.20836 5.04164L9 7.83327L11.7916 5.04164L12.9584 6.20836L10.1667 9L12.9584 11.7916Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol